import React from 'react'
import SplitPane from 'react-split-pane'
import Input from '../../views/Input/Input'
import Output from '../../views/Output/Output'

const TabletView = () => {
  return (
    <SplitPane defaultSize="33%" split="horizontal" minSize="33%">
      <Input />
      <Output />
    </SplitPane>
  )
}

export default TabletView
